import { createElement } from "react";
import IdeasDisplay from "./IdeasDisplay";
import { Display, sendVideoPlaybackState } from "src/pods/ideas";
import { useToolkitIdeasStore } from "src/pods/ideas/toolkitIdeasStore";
import { displayClose } from "src/pods/realtime";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

type SnapshotDisplay = {
  readonly watch: {
    readonly type: string;
    readonly hls_url?: string;
    readonly poster_url?: string;
    readonly captions?: readonly (readonly string[])[];
    readonly content?: string;
    readonly storyImageUrl?: string;
    readonly subtitle?: string;
  } | null;
  readonly question: {
    readonly text?: string;
    readonly storyImageUrl?: string;
  } | null;
  readonly isPlaying: boolean;
  readonly isFullscreen: boolean;
  readonly seekOffset: number;
};

function makeMutableDisplay(display: SnapshotDisplay): Display {
  return {
    ...display,
    watch: display.watch
      ? {
          ...display.watch,
          captions: display.watch.captions?.map((caption) => [...caption]),
        }
      : null,
    question: display.question ? { ...display.question } : null,
  };
}

export default function IdeasDisplayContainer() {
  const ideas = useToolkitIdeasStore();
  const display = makeMutableDisplay(ideas.display);

  return createElement(IdeasDisplay, {
    display,
    sendVideoPlaybackState: (value: boolean) => dispatchToolkitReduxAction(sendVideoPlaybackState(value)),
    displayClose: () => dispatchToolkitReduxAction(displayClose()),
  });
}
